<template>
    <div class="containersmall">
      <div id= "{{game._id ? game._id:game.id}}-middlesmall" :class="turnSmall">
        <div @click="showBoard(game, true)" id="{{game._id ? game._id:game.id}}-boardsmall" style="width:100%; height:170px;" :class="classboard"></div>
      </div>
      <div class="overlay" @click="showBoard(game, false)">
          <span class="col s12 m12 l12 valign-wrapper" v-if="game.u1 !== game.u2">
              <md-icon>people</md-icon>
              &nbsp;{{ game.u1 }} <b>&nbsp;VS&nbsp;</b> {{ game.u2 }}&nbsp;
              <span v-if="game.torneo && game.torneo.length > 0">{{ game.torneo }} ({{ game.ronda }})</span>
              <!-- <span style="font-size: smaller; margin-left: auto;">{{ generateHeader(game.pgn, true) }}</span>-->
          </span>
          <span class="col s12 m12 l12 valign-wrapper" v-if="game.u1 === game.u2">
              <md-icon>cast</md-icon>
              &nbsp;<b>{{ game.name }}</b>&nbsp;({{ game.u1 }})&nbsp;
              <!-- <p style="font-size: smaller;  margin-left: auto;"><span>{{ generateHeader(game.pgn, true) }}</span></p>-->
          </span>
      </div>
    </div>
</template>
<script>
// import Chess from 'chess.js'
import UserService from '../../services/user'
import Store from '../../services/lstorage'
import toast from 'vue-material-components'
// import Chessground from 'chessground'
// import Garbochess from '../../services/garbochess.js'
// import UserService from '../../services/user'
// import BoardHistory from '../game/boardHistory'
// import toast from 'vue-material-components'
// import Jquery from 'jquery'
// var intervalSmall = []
var stylesBoard = {
  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
}
export default {
  name: 'BoardVisorSmall',
  props: {
    game: {
      type: Object
    },
    classboard: {
      type: String
    },
    callbackFunction: {
      type: Function,
      required: false // Si la función no es obligatoria
    }
  },
  data () {
    return {
      // chess: new Chess(),
      styleboard: true,
      stylesBoard: stylesBoard,
      styles: Store.get('styleBoard',
        {
          board: 0,
          pieces: 0
        }),
      user: UserService.user,
      turnSmall: 'borderWhite',
      gameActual: []
    }
  },
  components: {
  },
  mixins: [
    toast
  ],
  events: {
    move (board) {
      // window.alert(board)
      if (this.game !== undefined && this.game._id === board.idBoard) {
        // this.toast('<span> BoardVisorSmall: </span>', 1000, 'rounded')
        this.changeStateGame(board.pgn, board.idBoard, board.fen)
        console.log('EVENTS move small changeStateGame')
      }
      console.log('EVENTS move small')
    }
  },
  methods: {
    /* deleteComment (pgn) {
      pgn = pgn.replace(/\{(.*?)\}/gmu, '')
      pgn = pgn.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
      pgn = pgn.replace(/\{(\s\S.+?)\}/gmu, '')
      return pgn
    },*/
    showBoard (board, open = false, event) {
      // window.alert(open)
      // Detenemos la propagación del evento
      if (event) {
        event.stopPropagation()
      }
      if (this.callbackFunction) {
        this.callbackFunction(board, open) // Llamamos a la función pasada como prop
      } else {
        console.log('No hay función de callback')
      }
    },
    hasBody (pgn) {
      var ret = false
      var newlineChar = '\r?\n'
      var lines = pgn.split(new RegExp(newlineChar))
      for (var i = 0; i < lines.length; i++) {
        // window.alert(lines[i])
        var linea = lines[i].trim()
        if (linea.length > 0 && linea[0] !== '['/* && lines[i].includes('.') */ && linea[0] !== '*') {
          // window.alert(linea)
          ret = true
          break
        }
      }
      return ret
    },
    parse_pgn_header (header) {
      var newlineChar = '\r?\n'
      var headerObj = {}
      var headers = header.split(new RegExp(newlineChar))
      var key = ''
      var value = ''
      for (var i = 0; i < headers.length; i++) {
        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1')
        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1')
        if (key.length > 0 && value.length > 0 && key !== value) {
          headerObj[key] = value
        }
      }
      return headerObj
    },
    cleanPGNContent (str) {
      return str.replace(/(\r?\n){2,}/g, '\n\n') // Mantener exactamente dos saltos entre partidas
        .replace(/\r?\n/g, (match, offset, string) => {
          const prevChar = string[offset - 1]
          const nextChar = string[offset + 1]
          // Si está entre partidas (dos saltos consecutivos), mantener el salto
          if (prevChar === '\n') {
            return match // No modificar, es parte de la separación entre partidas
          }
          // Si está dentro de los movimientos o comentarios
          if (prevChar === ']' || nextChar === '[') {
            return match // Mantener el salto de línea
          }
          return ' ' // Reemplazar con un espacio
        }).replace(/ {2,}/g, ' ') // Eliminar espacios dobles
    },
    prettyPgn (strParam) {
      // str = str.replace(/\u2605/g, '').replace(/\u0445/g, 'x')
      // str = ' ' + str.replace(/\./g, ' ').replace(/(\[FEN [^\]]+\])+?/g, function ($0, $1) { return $1.replace(/\[|\]|"/g, '').replace(/\s/g, '.') })
      // str = str.replace(/\[Event /g, '* [Event ').replace(/\s(\[[^\]]+\])+?/g, '').replace(/(\{[^\}]+\})+?/g, '')
      /* var r = /(\([^\(\)]+\))+?/g
      while (r.test(str)) {
        str = str.replace(r, '')
      }*/
      // window.alert(str)
      // str = decodeURIComponent((str))
      var str = strParam
      try {
        // Intentar decodificar la cadena como UTF-8
        // window.alert(strParam)
        str = Buffer.from(strParam, 'latin1').toString('utf8')
      } catch (e) {
        str = strParam
      }
      str = str.replace(/0-0-0/g, 'O-O-O').replace(/0-0/g, 'O-O') // .replace(/(1\-0|0\-1|1\/2\-1\/2)/g, ' * ').replace(/\s\d+/g, ' ').replace(/\$\d+/g, '').replace(/\?/g, '')
      str = this.cleanPGNContent(str)
      return str
    },
    changeStateGame (pgn, id, fen) {
      if (document.getElementById(id + '-middlesmall') !== null) {
        var Width = 160// document.getElementById(id + '-middlesmall').clientWidth
        var pgnBoard = 0
        var pos = 'end'
        var start = fen !== undefined ? fen : ''
        pgn = this.prettyPgn(pgn)
        // pgn = this.deleteComment(pgn)
        // pgn = pgn.split('"]').join('"]\n')
        // pgn = pgn.split('{}').join('')
        var headers = this.parse_pgn_header(pgn)
        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
          pos = fen !== undefined ? fen : 'end'
          if (!this.hasBody(pgn)) {
            start = ''
            pos = headers['FEN']
          }
          if (pos === headers['FEN']) {
            start = ''
          }
        }
        if (start === 'start' || start === 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1') {
          start = ''
          pos = fen
        }
        if (start === headers['FEN']) {
          start = ''
        }
        try {
          if (Width > 0 && pgn !== 'none' && pgn !== '' && typeof window.pgnView === 'function') {
            // window.alert('[FEN]' + fen)
            pgnBoard = window.pgnView({inner: id + '-boardsmall'}, {pgn: pgn, startPlay: start, position: pos, showCoords: false, width: Width}) // , orientation: (this.turnSmall === 'w') ? 'white' : 'black'})
          } else {
            pgnBoard = window.pgnView({inner: id + '-boardsmall'}, {pgn: '', position: '', showCoords: false, width: Width}) // , orientation: (this.turnSmall === 'w') ? 'white' : 'black'})
          }
          // this.turnSmall = pgnBoard.chess.turn() === 'w' ? 'borderWhite' : 'borderBlack'
          if (pgnBoard && pgnBoard.chess) {
            this.turnSmall = pgnBoard.chess.turn() === 'w' ? 'borderWhite' : 'borderBlack'
          }
        } catch (error) {
          console.error('<span>' + 'Error Mainchess (changeStateGame): ' + error + '</span>', 3000)
        }
      }
    },
    loadDataGame (board, force = false) {
      var data = {
        c: 'board',
        f: 'getBoardSmall', // f: 'getBoardSmall',
        data: board
      }
      // var self = this
      this.$socket.emit('event', data, function (...callbacks) {
        if (!callbacks[0]) {
          var boardGet = callbacks[1].board
          // window.alert('getBoardSmall')
          // window.alert('loadDataGame' + board.pgn)
          // boardGet.pgn = unescape(boardGet.pgn)
          // boardGet.pgn = boardGet.pgn.split('"]').join('"]\n\n')
          if ((boardGet !== undefined && this.gameActual[boardGet._id] && boardGet.pgn !== this.gameActual[boardGet._id].pgn) || force) {
            // window.alert('actual' + this.gameActual[boardGet._id].pgn)
            // window.alert(JSON.stringify(boardGet))
            // var pgn = boardGet.pgn.split('"]').join('"]\n\n')
            // this.chess.load_pgn(pgn)
            // this.turnSmall = this.chess.turn() === 'w' ? 'borderWhite' : 'borderBlack'
            var fen = boardGet.fen !== undefined ? boardGet.fen : 'end'
            this.changeStateGame(boardGet.pgn, boardGet._id, fen)
            boardGet.idBoard = boardGet._id
            Store.set(boardGet._id, boardGet)
            // this.changeStateGame(board.pgn, board.idBoard, board.fen)
          }
        } else {
          // window.alert('vaciii0')
        }
      }.bind(this))
    }
  },
  watch: {
    game (newVal, oldVal) {
      // window.alert(newVal)
      // this.loadDataGame(newVal, true)
    }
  },
  created () {
    // this.game.pgn = this.game.pgn.split('"]').join('"]\n')
    // this.game.pgn = this.game.pgn.split('{}').join('')
    if (this.game && this.game._id) {
      this.gameActual[this.game._id] = this.game
      this.game._id = this.game._id ? this.game._id : this.game.id
      this.loadDataGame(this.game, true)
    }
    // clearInterval(intervalSmall[this.game._id])
    /* intervalSmall[this.game._id] = setInterval(() => {
      this.loadDataGame(this.game)
    }, 1000)*/
  },
  attached () {
  },
  beforeDestroy () {
    // this.game._id = this.game._id ? this.game._id : this.game.id
    // clearInterval(intervalSmall[this.game._id])
  }
}
</script>

<style scoped>
  @import '../../../static/libs/simplechessboard.min.css';
  .userTurn {
    color: white ;
    font-size: large;
  }
  .borderWhite {
    border: 7px solid white;
  }
  .borderBlack {
    border: 7px solid black;
  }
  .check {
    background: radial-gradient(ellipse at center, rgb(123, 255, 0) 40%, rgba(231, 0, 0, 1) 40%, rgba(169, 0, 0, 0) 89%, rgba(158, 0, 0, 0) 100%);
  }
</style>



// WEBPACK FOOTER //
// boardVisorSmall.vue?2a25977a